import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Box, Button, Dialog, DialogContent, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { IDENTITY_VALIDATION_DECISION } from '../../../utils/identityValidation';

export default function IdentityValidationErrorDialog({
  open,
  outcome,
  onRetry,
  onManual,
  onClose,
}) {
  const { t } = useTranslation(['title', 'description', 'button']);
  const rejected = outcome === IDENTITY_VALIDATION_DECISION.REJECTED;
  const manual = outcome === IDENTITY_VALIDATION_DECISION.MANUAL;
  const descriptionKey = rejected
    ? 'routes.identity_validation.rejected_description'
    : manual
    ? 'routes.identity_validation.manual_error_description'
    : 'routes.identity_validation.error_description';
  const actionKey = rejected
    ? 'accept'
    : manual
    ? 'identity_validation.send_selfie_and_cnh'
    : 'identity_validation.take_new_selfie';

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      PaperProps={{
        sx: {
          borderRadius: '8px',
          m: 2,
          width: 'calc(100% - 32px)',
          boxShadow: '0px 8px 24px rgba(33, 33, 33, 0.18)',
        },
      }}
    >
      <DialogContent sx={{ px: 3, pt: 4, pb: 3, textAlign: 'center' }}>
        <ErrorOutlineIcon sx={{ fontSize: 48, color: '#BDBDBD', mb: 2 }} />
        <Typography
          component="h2"
          sx={{
            fontSize: 22,
            fontWeight: 700,
            lineHeight: 1.3,
            color: '#212121',
            mb: 2,
          }}
        >
          {t('identity_validation.error_title', { ns: 'title' })}
        </Typography>
        <Typography sx={{ fontSize: 16, lineHeight: 1.5, color: '#424242' }}>
          {t(descriptionKey, { ns: 'description' })}
        </Typography>
        <Box sx={{ mt: 3 }}>
          <Button
            type="button"
            variant="contained"
            fullWidth
            onClick={rejected ? onClose : manual ? onManual : onRetry}
            sx={{
              textTransform: 'uppercase',
              fontWeight: 700,
              fontSize: 14,
              boxShadow: 'none',
              borderRadius: '8px',
              py: 1.25,
              '&:hover': { boxShadow: 'none' },
            }}
          >
            {t(actionKey, { ns: 'button' })}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
